<template>
  <dashboard/>
   <div class="modal-dialog modal-lg downchange">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Change Password</h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Old Password</label>
                    <input type="text" v-if="showPassword1" v-model="old_password" @keyup="validateOldPass" class="form-control" />
                    <input type="password" v-else v-model="old_password" @keyup="validateOldPass" class="form-control" />
                    <i class="fas" @click="toggleShow1" :class="{ 'fa-eye': showPassword1, 'fa-eye-slash' : !showPassword1 }"></i>
                  </div>
                <div v-if="op_error" class="alertErrorRed">{{ op_error }}</div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>New Password</label>
                    <input type="text" v-if="showPassword2" v-model="new_password" @keyup="validatePass" class="form-control" />
                    <input type="password" v-else v-model="new_password" @keyup="validatePass" class="form-control" />
                    <i class="fas" @click="toggleShow2" :class="{ 'fa-eye': showPassword2, 'fa-eye-slash' : !showPassword2 }"></i>
                  </div>
                <div v-if="p_error" class="alertErrorRed">{{ p_error }}</div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Confirm Password</label>
                    <input type="text" v-if="showPassword3" v-model="confirm_password" @keyup="validateConfirmPass" class="form-control" />
                    <input type="password" v-else v-model="confirm_password" @keyup="validateConfirmPass" class="form-control" />
                    <i class="fas" @click="toggleShow3" :class="{ 'fa-eye': showPassword3, 'fa-eye-slash' : !showPassword3 }"></i>
                  </div>
                <div v-if="pc_error" class="alertErrorRed mb-1">{{ pc_error }}</div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <input type="button" @click="changepass" value="Save" class="modal-btn" />
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import axios from "../../services/customAxios";
import { base_url } from "../../config";
import Dashboard from '../../components/Dashboard.vue'
export default defineComponent({
  name: "ChangePass",
  components: { Dashboard },
  setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
  data(){
    return{
      result:[],  
      op_error:"",
      p_error:"",
      pc_error:"",
      old_password: "",
      new_password: "",
      confirm_password: "",
      base_url: base_url,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      email:localStorage.getItem("email")
    }
  },
  methods: {
    toggleShow1() {
      this.showPassword1 = !this.showPassword1
    },
     toggleShow2() {
      this.showPassword2 = !this.showPassword2
    },
     toggleShow3() {
      this.showPassword3 = !this.showPassword3
    },
    async changepass() {
      try{       
      let response = await axios.put(`${base_url}/change_password`,
        {
          email: this.email,
          old_password: this.old_password,
          new_password: this.new_password,
          confirm_password: this.confirm_password,
        }
      );
      console.log("response",response)
      console.log("Response status:", response.status); 
      console.log("Response data:", response.data); 
      createToast({title: "Success", description: response.data.message},{type: "success"})
      if(response.data.success == true){
          this.$router.push('/dashboard')
        }      
      } 
      catch(error){
        console.error("Error response:", error.response);
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
    },  
   cross(){
    window.location.reload();
   },
    validateOldPass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.old_password)) {
          this.op_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
      }else{
          this.op_error = '';
      }
    },
    validatePass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.new_password)) {
          this.p_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
      }else{
          this.p_error = '';
      }
    },
    validateConfirmPass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.confirm_password)) {
          this.pc_error = 'Password must have at least 8 Characters and at least 1 Uppercase Character, Lowercase Character, 1 Numeric and 1 Special Character';	
      }else{
          this.pc_error = '';
      }
    },
  },
});
</script>

<style>
.downchange{
    margin-top: 5%;
    margin-left: 30%;
}
</style>


<style scoped>
i.fas.fa-eye-slash,
i.fas.fa-eye {
   position: absolute;
    top: 60%;
    transform: translate(-50%, -50%);
    color: #3a494b;
    right: 16px;
    z-index:99
}
.form-group {
    position: relative;
}

i.fas.fa-eye-slash {
    top: 52px !important;
}
i.fas.fa-eye {
    top: 52px !important;
}
.alertErrorRed {
    color: red;
    font-size: 14px;
    margin-bottom: 0;
    margin-top: 0;
}
</style>